import { ValidatorFn, Validators } from "@angular/forms";
import { isNullOrWhitespace } from ".";

export const nameValidator: ValidatorFn[] = [
    Validators.required,
    isNullOrWhitespace
];